import { Stack } from "expo-router"

import { useAppTheme } from "src/hooks/useAppTheme"

export default function RootLayout() {
  const {
    theme: { colors },
  } = useAppTheme()

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        navigationBarColor: colors.background,
        contentStyle: {
          backgroundColor: colors.background,
        },
      }}
      initialRouteName="accept-terms"
    >
      <Stack.Screen name="accept-terms" options={{ headerShown: false }} />
      <Stack.Screen name="accept-ai-processing" options={{ headerShown: false }} />
      <Stack.Screen
        name="select-sponsor"
        options={{
          title: "Select Channel",
          headerShown: true,
          headerTitleAlign: "center",
          headerShadowVisible: false,
          headerStyle: { backgroundColor: colors.background },
          headerTintColor: colors.text,
        }}
      />
      <Stack.Screen name="channel-access-denied" options={{ headerShown: false }} />
    </Stack>
  )
}
